import React, { useState } from 'react';
import NftImage from './NftImage';
import Button from './Button';
import { useStaking } from '../hooks/useStaking';
import { useAlgo } from '../hooks/useAlgo';
import { toast } from 'react-toastify';

function StakingPreview({ daruma }) {
  const { optIn } = useAlgo();
  const { stakeDaruma, myEligibleDarumas, stakedDarumas } = useStaking();
  const [loading, setLoading] = useState(false);

  const isEligible = myEligibleDarumas.map((it) => it.index).includes(daruma.index);
  const isStaked = stakedDarumas.map((it) => it.index).includes(daruma.index);

  let buttonLabel = 'Stake';
  if (isStaked) {
    buttonLabel = 'Staked';
  } else if (!isEligible) {
    buttonLabel = 'Not eligible';
  }

  const onStake = async (shouldStake) => {
    setLoading(true);

    try {
      if (shouldStake) {
        await optIn(parseInt(process.env.NEXT_PUBLIC_TOKEN_ID));
      }
      await stakeDaruma(daruma, shouldStake);
    } catch (error) {
      console.log(error);
      toast.error('Error staking');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className='relative mb-2 overflow-hidden bg-gray-800 rounded-md aspect-square'>
        <NftImage nft={daruma} spinnerDimensionClasses='w-12 h-12' />
      </div>
      <div className='mb-6'>
        <p className='text-lg font-bold text-gray-500'>{daruma?.params?.name}</p>
        <p className='text-base italic text-gray-500'>Earns 5 KARMA per staking period</p>
      </div>
      <div className='space-y-4'>
        <Button disabled={!isEligible || isStaked} onClick={() => onStake(true)} loading={loading} className='w-full'>
          {buttonLabel}
        </Button>

        {isStaked && (
          <Button theme='link' onClick={() => onStake(false)} loading={loading} className='w-full'>
            Unstake
          </Button>
        )}
      </div>
    </div>
  );
}

export default StakingPreview;
